import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const RollbarIntegration = React.lazy(() => import("./RollbarIntegration"));

interface RollbarIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
  initialAccountName?: string;
}

// Match PagerDutyIntegration-lazy pattern exactly - no early return
export default function RollbarIntegrationLazy(props: RollbarIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <RollbarIntegration {...props} />
    </Suspense>
  );
}
